import { useState, useEffect, useCallback } from 'react'
import graphql from '../services/graphql'
import { getStoreById } from '../shoplist-app/store-profile/queries'
import logger from '../lib/logger'
import { get } from 'lodash'
import { EVENT_ORIGIN } from 'graphql/constants/eventOrigin'

import { StoreDetail } from '../shoplist-app/shopping/types/ShoppingPageType'
/***
 *  Use custom hook to carete a function we can use to get all shopping profile sections .
 *  See more here(https://reactjs.org/docs/hooks-custom.html)
 */

export const useStoreProfileData = (merchantId: string) => {
  const [store, setStore] = useState<StoreDetail>()
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | undefined>()
  const fetchAllSections = useCallback(async () => {
    try {
      const {
        data: { data, errors }
      } = await graphql(getStoreById, {
        merchantId,
        eventOrigin: EVENT_ORIGIN.STORE_DETAILS
      })
      if (errors) {
        logger.error('useStoreProfileDataHook', errors)
        throw new Error(JSON.stringify(errors))
      }
      setStore(get(data, 'uiShopping.stores.stores[0]', []))
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [merchantId])

  useEffect(() => {
    setLoading(true)
    fetchAllSections()
  }, [fetchAllSections, merchantId])

  /**
   * sections : store profile section
   * loading : indicator loader for the call
   * error : if the call has any error
   */

  return {
    loading,
    error,
    store
  }
}
